import React from 'react';
import { Card, CardContent } from './ui/card';
import { leadershipData } from '../data/mock';

export const Leadership = () => {
  // Separate mayor candidate from council candidates
  const mayorCandidate = leadershipData.leaders[0];
  const councilCandidates = leadershipData.leaders.slice(1);

  return (
    <section id="leadership" className="py-20 bg-gradient-to-b from-cyan-50/30 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {leadershipData.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {leadershipData.subtitle}
          </p>
        </div>

        {/* Mayor Candidate - Large Centered Card */}
        <div className="max-w-md mx-auto mb-16">
          <Card className="group overflow-hidden border-2 border-cyan-300 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            {/* Image */}
            <div className="relative h-80 overflow-hidden bg-gray-100">
              <img
                src={mayorCandidate.image}
                alt={mayorCandidate.name}
                loading="eager"
                fetchpriority="high"
                decoding="async"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                style={{ objectPosition: 'center -30px' }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              
              {/* Role Badge */}
              <div className="absolute bottom-4 left-4 right-4">
                <div className="bg-cyan-500 text-white px-4 py-2 rounded-lg text-center">
                  <p className="text-lg font-bold">{mayorCandidate.role}</p>
                </div>
              </div>
            </div>

            <CardContent className="p-8 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors">
                {mayorCandidate.name}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {mayorCandidate.bio}
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Council Candidates Grid */}
        <div className="max-w-7xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10">
            Candidati Consiglieri
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {councilCandidates.map((leader) => (
              <Card
                key={leader.id}
                className="group overflow-hidden border-2 border-gray-100 hover:border-cyan-300 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-56 overflow-hidden bg-gray-100">
                  <img
                    src={leader.image}
                    alt={leader.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    style={leader.id === 12 ? { objectPosition: 'center -20px' } : {}}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                <CardContent className="p-5">
                  <h3 className="text-base font-bold text-gray-900 mb-1 group-hover:text-cyan-600 transition-colors">
                    {leader.name}
                  </h3>
                  <p className="text-xs font-medium text-cyan-600 mb-3">
                    {leader.role}
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    {leader.bio}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
